export default "__VITE_ASSET__30bdb263__"